import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor, _descriptor2;
import { action } from "@ember/object";
import { next } from "@ember/runloop";
import { service } from "@ember/service";
import DiscourseRoute from "discourse/routes/discourse";
let SignupRoute = (_class = class SignupRoute extends DiscourseRoute {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "router", _descriptor, this);
    _initializerDefineProperty(this, "siteSettings", _descriptor2, this);
  }
  beforeModel() {
    this.showCreateAccount();
  }
  async showCreateAccount() {
    const {
      canSignUp
    } = this.controllerFor("application");
    const route = await this.router.replaceWith(this.siteSettings.login_required ? "login" : "discovery.latest").followRedirects();
    if (canSignUp) {
      next(() => route.send("showCreateAccount"));
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "siteSettings", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "showCreateAccount", [action], Object.getOwnPropertyDescriptor(_class.prototype, "showCreateAccount"), _class.prototype)), _class);
export { SignupRoute as default };